import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function TelegramCompanionPanel() {
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);
  const [link, setLink] = useState("");
  useEffect(() => {
    let alive = true;
    const refresh = async () => {
      try {
        const response = await api.get("/telegram-control");
        if (alive) setState(response.data);
      } catch { if (alive) setState(null); }
    };
    refresh();
    const timer = setInterval(refresh, 10000);
    return () => { alive = false; clearInterval(timer); };
  }, []);

  const act = async (operation) => {
    setBusy(true);
    try {
      if (operation === "link") {
        const response = await api.post("/telegram-control/link");
        setLink(response.data.url);
      } else if (operation === "confirm") {
        await api.post("/telegram-control/confirm", { generation: state.pending.generation });
        setLink("");
        toast.success("Telegram terhubung. Ketik /status pada bot.");
      } else {
        await api.delete("/telegram-control");
        setLink("");
        toast.success("Penghubung Telegram diputus.");
      }
      const response = await api.get("/telegram-control");
      setState(response.data);
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Penghubung belum tersedia. Coba lagi nanti.");
    } finally { setBusy(false); }
  };
  // Existing deployments without the companion API keep their notification UI.
  if (!state) return null;
  return (
    <section className="rounded-2xl border border-blue-400/20 bg-blue-500/5 p-4 space-y-3" data-testid="telegram-companion">
      <h2 className="font-heading font-bold">Bot Telegram pendamping</h2>
      <p className="text-sm text-slate-300">
        Lihat status akun, terima pemberitahuan verifikasi, FloodWait, dan pengaman Telegram, serta mulai, hentikan, atau lanjutkan bot dari Telegram.
        Verifikasi yang memerlukan tindakan manual tetap diselesaikan pada akun Telegram yang bersangkutan.
      </p>
      {state.linked ? (
        <>
          <p className="text-sm text-emerald-400">Telegram terhubung. Pemberitahuan {state.notifications ? "aktif" : "mati"}; atur lewat /settings.</p>
          {!state.available && <p className="text-sm text-amber-300">Bot pendamping sedang tidak tersedia.</p>}
          <Button variant="outline" disabled={busy} onClick={() => act("unlink")}>Putuskan penghubung</Button>
        </>
      ) : state.pending ? (
        <>
          <p className="text-sm">Permintaan dari Telegram: <strong>{state.pending.telegram_name}</strong>.</p>
          <p className="text-xs text-slate-400">Konfirmasikan hanya jika nama ini milik Anda. Bot akan menerima pemberitahuan dan dapat mengontrol akun milik Anda.</p>
          <div className="flex gap-2 flex-wrap">
            <Button disabled={busy} onClick={() => act("confirm")}>Ya, ini Telegram saya</Button>
            <Button variant="outline" disabled={busy} onClick={() => act("unlink")}>Batalkan</Button>
          </div>
        </>
      ) : state.available ? (
        <>
          {state.stale && <p className="text-sm text-amber-300">Penghubung Telegram sebelumnya sudah kedaluwarsa. Hubungkan ulang untuk menerima notifikasi FishKa.</p>}
          <Button disabled={busy} onClick={() => act("link")}>{state.stale ? "Hubungkan ulang" : "Buat tautan penghubung"}</Button>
          {state.stale && <Button variant="outline" disabled={busy} onClick={() => act("unlink")}>Putuskan penghubung lama</Button>}
          {link && <div className="space-y-2">
            <a href={link} target="_blank" rel="noopener noreferrer" className="inline-block text-blue-300 underline">Buka bot Telegram dan tekan Start</a>
            <p className="text-xs text-slate-400">Berlaku 10 menit. Jangan bagikan tautan. Kembali ke halaman ini sekali untuk konfirmasi.</p>
          </div>}
        </>
      ) : <>
        <p className="text-sm text-slate-400">Bot pendamping belum aktif. Admin sedang menyiapkan penghubung.</p>
        {state.stale && <Button variant="outline" disabled={busy} onClick={() => act("unlink")}>Putuskan penghubung lama</Button>}
      </>}
    </section>
  );
}
